import './styles.scss';

export default {
    name: 'CheckboxGroup',

    props: {
        all_title: String,
        list: Array
    },

    data() {
        return {
            options: [],
            all: true,
            hide: true
        };
    },

    created() {
        this.all = this.list.every((option) => {
            return option.isChecked;
        });
        
        this.options = this.list;
        setTimeout(() => {
            this.hide = false;
        }, 100);
    },

    methods: {
        changeAll() { 
            this.all = !this.all;

            this.options.map(((option) => {
                option.isChecked = this.all;
            }));

            this.$emit('update', this.options);
        },

        changeValue(value, index) {
            this.options[index].isChecked = value;

            this.all = this.options.every((option) => {
                return option.isChecked;
            });

            this.$emit('update', this.options);
        }
    }
};